var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2 12.8906C2 7.36778 6.47715 2.89062 12 2.89062C17.5228 2.89062 22 7.36778 22 12.8906C22 18.4135 17.5228 22.8906 12 22.8906C6.47715 22.8906 2 18.4135 2 12.8906ZM11.9993 10.4604C12.4964 10.4604 12.9001 10.0575 12.9001 9.56045C12.9001 9.06339 12.4971 8.66045 12.0001 8.66045C11.503 8.66045 11.0993 9.06339 11.0993 9.56045C11.0993 10.0575 11.5023 10.4604 11.9993 10.4604ZM11.2501 16.3298C11.2501 16.744 11.5859 17.0798 12.0001 17.0798C12.4143 17.0798 12.7501 16.744 12.7501 16.3298V12.1054C12.7501 11.6912 12.4143 11.3554 12.0001 11.3554C11.5858 11.3554 11.2501 11.6912 11.2501 12.1054V16.3298Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.0795C11.5859 17.0795 11.2501 16.7437 11.2501 16.3295V12.1051C11.2501 11.6909 11.5859 11.3551 12.0001 11.3551C12.4143 11.3551 12.7501 11.6909 12.7501 12.1051V16.3295C12.7501 16.7437 12.4143 17.0795 12.0001 17.0795Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0994 9.56016C11.0994 10.0572 11.5023 10.4602 11.9994 10.4602C12.4964 10.4602 12.9001 10.0572 12.9001 9.56016C12.9001 9.0631 12.4972 8.66016 12.0001 8.66016C11.5031 8.66016 11.0994 9.0631 11.0994 9.56016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.75995ad95d3966245ccec839f31f27fe.svg";
export { ForwardRef as ReactComponent };